export class EvkSeccionModel {

    origen: string;
    propiedades: any;
}
